import { memo } from 'react';
import { GiveawayDetailedArchive } from '@/entities/giveaway/types';
import styles from './DetailedGiveawayArchiveInfo.module.scss';
import { TimeDisplay } from '@/utils/TimeDisplay';
import { ReactComponent as CalendarIcon } from '@/assets/Icons/calendar.svg';
import { ReactComponent as UsersIcon } from '@/assets/Icons/users.svg';
import { LottieAnimation } from '@/components/LottieAnimation';
import { TelegramSticker } from '@/components/TelegramSticker';
import rayWinnerAnimation from '@/assets/ray-lottie.json';
import Button from '@/components/Button/Button';
import cleanUrl from '@/utils/cleanUrl';
import { useWordDeclension } from '@/utils/wordDeclension';
import { getGiveawayCoupons } from '@/api/modules/giveaway';
import stars from '@/assets/starts.json';
interface DetailedGiveawayArchiveInfoProps {
  giveaway: GiveawayDetailedArchive;
}

const DetailedGiveawayArchiveInfo = ({
  giveaway,
}: DetailedGiveawayArchiveInfoProps) => {
  const PrizeItem = memo(({ item_url }: { item_url: string }) => {
    return (
      <TelegramSticker
        tgsUrl={cleanUrl(item_url!)}
        loop={true}
        autoplay={true}
      />
    );
  });

  const handleClaim = async () => {
    try {
      const response = await getGiveawayCoupons(
        giveaway.id,
        giveaway.user_metadata.prizes[0].place,
      );
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.giveawayDetails}>
      <div className={styles.giveawayTitle}>{giveaway?.name}</div>
      <div className={styles.timeContainer}>
        <div className={styles.date}>
          <div className={styles.dateValue}>
            <TimeDisplay endDate={giveaway.end_date} format="short" />
            <CalendarIcon className={styles.calendarIcon} />
          </div>
          <div className={styles.dateText}>Дата проведения</div>
        </div>
        <div className={styles.date}>
          <div className={styles.dateValue}>
            {giveaway.members}
            <UsersIcon className={styles.usersIcon} />
          </div>
          <div className={styles.dateText}>Число участников</div>
        </div>
      </div>
      {giveaway.user_metadata.is_member && (
        <div
          className={
            giveaway.user_metadata.prizes[0].is_claimed
              ? styles.prizeContainerClaimed
              : styles.prizeContainer
          }
        >
          <LottieAnimation
            animationData={rayWinnerAnimation}
            autoplay
            loop
            style={{
              position: 'absolute',
              top: '50%',
              right: '15%',
              transform: 'translate(50%, -50%)',
              width: '300px',
              height: '300px',
              zIndex: -1,
            }}
          />

          {giveaway.user_metadata.prizes[0].currency_type !== 'nfts' ? (
            <>
              {/* <div className={styles.prizeStatic}>
                <img
                  src={
                    giveaway.prizes.find(
                      (prize) =>
                        giveaway.user_metadata.prizes[0].place >=
                          prize.start_range &&
                        giveaway.user_metadata.prizes[0].place <=
                          prize.end_range,
                    )?.image_url
                  }
                  alt="prize"
                  className={styles.prizeStaticImage}
                />
              </div> */}

              <div
                className={
                  giveaway.user_metadata.prizes[0].is_claimed
                    ? styles.prizeNftClaimedStatic
                    : styles.prizeNftStatic
                }
              >
                <LottieAnimation animationData={stars} autoplay loop />
              </div>

              <div className={styles.giveawayInfo}>
                <div className={styles.giveawaySubheader}>Твой приз:</div>
                <div className={styles.giveawayHeaderStatic}>
                  {giveaway.user_metadata.prizes[0].quantity}{' '}
                  {useWordDeclension(
                    giveaway.user_metadata.prizes[0].quantity,
                    {
                      one: 'звезда',
                      few: 'звезды',
                      many: 'звезд',
                    },
                  )}
                </div>

                <div className={styles.giveawayClaim}>
                  <Button
                    onClick={handleClaim}
                    disabled={giveaway.user_metadata.prizes[0].is_claimed}
                  >
                    Получить
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className={
                  giveaway.user_metadata.prizes[0].is_claimed
                    ? styles.prizeNftClaimed
                    : styles.prizeNft
                }
                onClick={() => {
                  const detailsUrl = giveaway.prizes.find(
                    (prize) =>
                      giveaway.user_metadata.prizes[0].place >=
                        prize.start_range &&
                      giveaway.user_metadata.prizes[0].place <= prize.end_range,
                  )?.details_url;

                  if (detailsUrl) {
                    window?.Telegram?.WebApp?.openTelegramLink(detailsUrl);
                  }
                }}
              >
                <PrizeItem
                  item_url={
                    giveaway.prizes.find(
                      (prize) =>
                        giveaway.user_metadata.prizes[0].place >=
                          prize.start_range &&
                        giveaway.user_metadata.prizes[0].place <=
                          prize.end_range,
                    )?.image_url_with_bg ?? ''
                  }
                />
              </div>

              <div className={styles.giveawayInfo}>
                <div className={styles.giveawaySubheader}>Твой приз:</div>
                <div className={styles.giveawayHeader}>
                  {giveaway.user_metadata.prizes[0].name}
                </div>
                <div className={styles.giveawaySubheader}>
                  #{giveaway.user_metadata.prizes[0].id}
                </div>
                <div className={styles.giveawayClaim}>
                  <Button
                    onClick={handleClaim}
                    disabled={giveaway.user_metadata.prizes[0].is_claimed}
                  >
                    Получить
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailedGiveawayArchiveInfo;
